import type { Discipline } from '@/domain/model/Discipline';
import type { GetMatriculaDisciplinesUseCase } from '@/application/port/in/GetMatriculaDisciplinesUseCase';
import type { DisciplineGateway } from '@/application/port/out/DisciplineGateway';

export class GetMatriculaDisciplines implements GetMatriculaDisciplinesUseCase {
  constructor(private readonly gateway: DisciplineGateway) {}
  execute(matriculaId: string): Promise<Discipline[]> {
    return this.gateway.listByMatricula(matriculaId);
  }
}
